<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.subgrupo"
        ref="DataTable"
        sort-by="nome"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click.stop="$router.push({ name: 'cadastro-subgrupo-edit', params: { id: item.id } })"
                color="primary"
                authorize="update-cadastro-subgrupo"
                title="Editar"
                small
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="handleDestroy(item)"
                color="danger"
                authorize="destroy-cadastro-subgrupo"
                title="Excluir"
                small
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import { repository, error } from '@/mixins'

export default {
    created() {

        this.repositories = {
            subgrupo: this.getConectaSusRepository('cadastro.subgrupo')
        }
    },
    computed: {

        fields() {

            return [
                {
                    name: 'nome',
                    key: 'nome',
                    label: 'Nome',
                    searchable: true,
                    sortable: true
                },
                {
                    name: 'cadastro_grupo.nome',
                    key: 'grupo',
                    label: 'Grupo',
                    searchable: true,
                    sortable: true
                },
                {
                    name: 'actions',
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        }
    },
    methods: {
        handleDestroy({ id }) {

            const destroy = () => this.repositories.subgrupo.destroy(id)
                .then(() => this.$refs.DataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir o subgrupo?', destroy, this.handleError)
        },
    },
    mixins: [ repository, error ],
}
</script>